<div class="sidebar-header noMobile">
  <h1>
    <!-- <ion-icon *ngIf="showPreviousVaccination" (click)="gotoStep('prev')" class="custom-arrow-left"></ion-icon> -->
    {{ "Member Vaccination" | translate }}
    <ion-icon (click)="closeDialog()" class="custom-close"></ion-icon>
  </h1>
</div>
<ion-header class="noDesktop mobile-header-white">
  <ion-toolbar class="ion-no-padding">
    <ion-buttons slot="start">
      <ion-back-button
        (click)="gotoStep('prev')"
        text=""
        ios="chevron-back-outline"
        md="arrow-back-outline"
        class="ion-margin-end"
      ></ion-back-button>
    </ion-buttons>
    <h4 class="heading">
      {{ "Member Vaccination" | translate }}
    </h4>
  </ion-toolbar>
</ion-header>
<ion-grid class="memberDetails ion-margin ion-no-padding">
  <ion-row>
    <ion-col class="ion-no-padding">
      <ion-accordion-group>
        <ion-accordion value="first">
          <ion-item slot="header" color="light">
            <h1 class="pageSubTitle">
              {{ verifiedData.ben_name }}
              <p>
                <ion-text>{{
                  verifiedData.beneficiary_gender | translate
                }}</ion-text
                ><ion-text
                  ><span *ngIf="verifiedData.dob">{{
                    verifiedData.dob | age
                  }}</span
                  ><span *ngIf="!verifiedData.dob && verifiedData.year">{{
                    verifiedData.year | age : "Y"
                  }}</span></ion-text
                ><ion-text>{{
                  verifiedData.dob || verifiedData.year
                }}</ion-text>
              </p>
            </h1>
          </ion-item>
          <div class="ion-padding" slot="content">
            <ion-grid class="memberInfo">
              <ion-row>
                <ion-col size="6">
                  <h5>{{ "MOBILE" | translate }}</h5>
                  <h3>{{ verifiedData.ben_mobile_number }}</h3>
                </ion-col>
                <ion-col size="6" class="ion-text-end">
                  <h5>{{ "IDENTIFICATION TYPE" | translate }}</h5>
                  <h3>{{ verifiedData.photo_id_type | translate }}</h3>
                </ion-col>
                <ion-col size="6">
                  <h5>{{ "IDENTIFICATION NO" | translate }}</h5>
                  <h3>{{ util.mask(verifiedData.photo_id_number) }}</h3>
                </ion-col>
                <ion-col
                  size="6"
                  class="ion-text-end"
                  *ngIf="verifiedData.blood_group"
                >
                  <h5>{{ "BLOOD GROUP" | translate }}</h5>
                  <h3>{{ verifiedData.blood_group }}</h3>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </ion-col>
  </ion-row>
</ion-grid>
<form [formGroup]="form">
  <div class="sidebar-content inputFields">
    <ion-grid class="sidebar-inner-content multi-vaccination">
      <ng-container *ngIf="selectedIndex === 0">
        <!-- <ion-row>
              <ion-col size="12" class="ion-no-padding">
                <h3 class="pageSubTitle">{{!showPreviousVaccination ? 'Current Vaccination' : 'Previous Vaccination'}}</h3>
              </ion-col>
            </ion-row> -->

        <ion-row *ngIf="villageState.villageArr()?.length > 0">
          <ion-col size-md="12" class="ion-no-padding">
            <ion-label>{{ "LGD Village" | translate }}</ion-label>
            <mat-form-field
              appearance="outline"
              class="ion-margin-vertical matDropdown"
            >
              <mat-select
                (selectionChange)="onChangelocation('villageId')"
                [placeholder]="'Select from the list' | translate"
                formControlName="village_id"
              >
                <mat-option
                  *ngFor="let village of villageState.villageArr()"
                  [value]="village.village_id"
                >
                  {{ village.village_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="villageState.healthVillageArr().length">
          <ion-col size-md="12" class="ion-no-padding">
            <ion-label>{{ "Health Village" | translate }}</ion-label>
            <mat-form-field
              appearance="outline"
              class="ion-margin-vertical matDropdown"
            >
              <mat-select
                (selectionChange)="onChangelocation('healthVillageId')"
                [placeholder]="'Select from the list' | translate"
                formControlName="health_village_id"
              >
                <mat-option
                  *ngFor="let healthVillage of villageState.healthVillageArr()"
                  [value]="healthVillage.village_id"
                >
                  {{ healthVillage.village_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="villageState.wardArr().length > 0">
          <ion-col size-md="12" class="ion-no-padding">
            <ion-label>{{ "LGD Ward" | translate }}</ion-label>
            <mat-form-field
              appearance="outline"
              class="ion-margin-vertical matDropdown"
            >
              <mat-select
                (selectionChange)="onChangelocation('wardId')"
                [placeholder]="'Select from the list' | translate"
                formControlName="ward_id"
              >
                <mat-option
                  *ngFor="let w of villageState.wardArr()"
                  [value]="w.ward_id"
                >
                  {{ w.ward_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="villageState.healthWardArr().length > 0">
          <ion-col size-md="12" class="ion-no-padding">
            <ion-label>{{ "Health Wards" | translate }}</ion-label>
            <mat-form-field
              appearance="outline"
              class="ion-margin-vertical matDropdown"
            >
              <mat-select
                (selectionChange)="onChangelocation('healthWardId')"
                [placeholder]="'Select from the list' | translate"
                formControlName="health_ward_id"
              >
                <mat-option
                  *ngFor="let hw of villageState.healthWardArr()"
                  [value]="hw.add_ward_id"
                >
                  {{ hw.add_ward_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="
            verifiedData?.asha_name &&
            commonStore.appConfigData()?.asha_incentives_access
          "
          class="ion-padding-bottom"
        >
          <ion-col size-md="12" class="verifiedLblView">
            <ion-label>{{
              "Confirmed linked ASHA worker" | translate
            }}</ion-label>
            <ion-text
              >{{ verifiedData?.asha_mobile }} -
              {{ verifiedData?.asha_name }}</ion-text
            >
          </ion-col>
        </ion-row>
        <ion-row> </ion-row>
        <ion-row *ngIf="this.ashaListState.ashaList().length">
          <ion-col size-md="12" class="ion-no-padding">
            <ion-label>{{ "Asha" | translate }}</ion-label>
            <mat-form-field
              appearance="outline"
              class="ion-margin-vertical matDropdown"
            >
              <mat-select
                [placeholder]="'Select from the list' | translate"
                formControlName="asha_user_id"
              >
                <mat-option
                  *ngFor="let asha of this.ashaListState.ashaList()"
                  [value]="asha?.user_id"
                >
                  {{ asha?.mobile_number }}-{{ asha?.display_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        </ion-row>
        <ion-row class="inputFields">
          <ion-col size-md="12" class="ion-no-padding ion-margin-bottom">
            <span class="checkboxSpan">
              <mat-checkbox
                formControlName="tag_session_site"
                color="primary"
                (change)="handleSessionSiteAndVillage($event)"
              >
                {{ "Tag To Session Site" | translate }}
              </mat-checkbox>
            </span>
            <!-- <ion-label>{{'Tag To Session Site' | translate}}</ion-label>
            <mat-radio-group aria-label="Select an option" formControlName="tag_session_site"
              (change)="handleSessionSiteAndVillage($event)">
              <mat-radio-button [value]='true'>Yes</mat-radio-button>
              <mat-radio-button [value]='false'>No</mat-radio-button>
            </mat-radio-group> -->
          </ion-col>
        </ion-row>
      </ng-container>
      <mat-tab-group (selectedIndexChange)="onTabChange($event)">
        <mat-tab [label]="'Current Vaccination' | translate">
          <app-current-vaccination
            *ngIf="selectedIndex === 0"
          ></app-current-vaccination>
        </mat-tab>
        <mat-tab
          [disabled]="disablePreviousVaccinationTab()"
          [label]="'Previous Vaccination' | translate"
        >
          <app-generic-previous-vaccination
            *ngIf="selectedIndex === 1"
          ></app-generic-previous-vaccination>
        </mat-tab>
      </mat-tab-group>
    </ion-grid>
  </div>
  <div class="sidebar-footer">
    <ion-row>
      <ion-col size-md="12">
        <ion-button class="primaryBtn" expand="full" shape="round" type="submit"
          >{{ "Save & Continue" | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</form>
